import { render } from "./InterventoDetail.vue?vue&type=template&id=58e020e9&scoped=true"
import script from "./InterventoDetail.vue?vue&type=script&lang=js"
export * from "./InterventoDetail.vue?vue&type=script&lang=js"

import "./InterventoDetail.vue?vue&type=style&index=0&id=58e020e9&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e020e9"]])

export default __exports__